import React from 'react';
import { ImmersiveModal, Button, AnchorLinkButton } from 'radiance-ui';
import { StaticImage } from 'gatsby-plugin-image';

import { EXTERNAL_URLS } from 'consts/externalUrls';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';

import {
  BodyTitle,
  CtaContainer,
  modalHeaderImageStyles,
} from './FinancialAssistanceModal.style';

export const FinancialAssistanceModal = ({
  onClose,
}: {
  onClose: () => void;
}) => (
  <ImmersiveModal
    onClose={onClose}
    headerImage={
      <StaticImage
        src="../images/access-program-modal-header@2x.jpg"
        alt="Curology bottles floating in water"
        css={modalHeaderImageStyles}
      />
    }
  >
    <BodyTitle>
      Find out if you qualify for the Curology Access Program
    </BodyTitle>
    <p>
      Every month, Curology provides a credit of up to $400 to 70 people who
      provide documentation of financial need (such as Medicaid, WIC, SNAP/food
      stamps, etc.). This credit allows recipients to access Curology's
      top-quality skincare products and services at absolutely no cost to them.
    </p>
    <CtaContainer>
      <Button
        buttonType="secondary"
        onClick={() => navExternalWithQueryString(EXTERNAL_URLS.accessProgram)}
      >
        Apply Now
      </Button>
      <AnchorLinkButton
        onClick={() =>
          navExternalWithQueryString(EXTERNAL_URLS.learnMoreAccessProgram)
        }
      >
        Learn more about the program
      </AnchorLinkButton>
    </CtaContainer>
  </ImmersiveModal>
);
